const GetCenterOfPolygon = values => {
    let polygonvalues = [].concat.apply([], values);

    const longitudes = [];
    const latitudes = [];
    for (let i = 0; i < polygonvalues.length; i++) {
        longitudes.push(polygonvalues[i].lng);
        latitudes.push(polygonvalues[i].lat);
    }

    latitudes.sort();
    longitudes.sort();
    const lowX = latitudes[0];
    const highX = latitudes[latitudes.length - 1];
    const lowy = longitudes[0];
    const highy = longitudes[latitudes.length - 1];
    const centerX = lowX + ((highX - lowX) / 2);
    const centerY = lowy + ((highy - lowy) / 2);

    return ({ lat: centerX, lng: centerY });
}

export default GetCenterOfPolygon;